/* TCG Shrine — Theme JS */

// === LANGUAGE TOGGLE (EN / IT) ===
const LANG_STORAGE_KEY = 'tcgshrine_lang';

const I18N_STRINGS = {
  en: {
    adding: 'Adding...',
    added: 'Added ✓',
    addedToCart: 'Added to Cart ✓',
    addToCart: 'Add to Cart',
    preorderNow: 'Preorder Now',
    error: 'Error',
    errorRetry: 'Error — Try Again'
  },
  it: {
    adding: 'Aggiunta...',
    added: 'Aggiunto ✓',
    addedToCart: 'Aggiunto al Carrello ✓',
    addToCart: 'Aggiungi al Carrello',
    preorderNow: 'Preordina Ora',
    error: 'Errore',
    errorRetry: 'Errore — Riprova'
  }
};

function currentLang() {
  return document.documentElement.getAttribute('data-lang') || 'en';
}

function t(key) {
  const lang = currentLang();
  return (I18N_STRINGS[lang] && I18N_STRINGS[lang][key]) || I18N_STRINGS.en[key];
}

function applyLang(lang) {
  document.documentElement.setAttribute('data-lang', lang);

  document.querySelectorAll('.js-i18n').forEach(el => {
    const value = lang === 'it' ? el.getAttribute('data-it') : el.getAttribute('data-en');
    if (value !== null) el.innerHTML = value;
  });

  document.querySelectorAll('.js-i18n-placeholder').forEach(el => {
    const value = lang === 'it' ? el.getAttribute('data-it') : el.getAttribute('data-en');
    if (value !== null) el.setAttribute('placeholder', value);
  });

  document.querySelectorAll('[data-lang-btn]').forEach(btn => {
    btn.classList.toggle('active', btn.dataset.langBtn === lang);
  });

  document.querySelectorAll('[data-lang-single]').forEach(btn => {
    btn.textContent = lang === 'it' ? 'IT' : 'EN';
    btn.setAttribute('aria-label', lang === 'it' ? 'Switch to English' : 'Passa a Italiano');
  });

  try { localStorage.setItem(LANG_STORAGE_KEY, lang); } catch (e) {}
}

function initLangToggle() {
  let saved = 'en';
  try { saved = localStorage.getItem(LANG_STORAGE_KEY) || 'en'; } catch (e) {}
  applyLang(saved);

  document.querySelectorAll('[data-lang-btn]').forEach(btn => {
    btn.addEventListener('click', () => applyLang(btn.dataset.langBtn));
  });

  document.querySelectorAll('[data-lang-single]').forEach(btn => {
    btn.addEventListener('click', () => applyLang(currentLang() === 'it' ? 'en' : 'it'));
  });
}

initLangToggle();

// === CART COUNT UPDATE ===
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const el = document.getElementById('cart-count');
      if (el) el.textContent = cart.item_count;
    });
}

// === ADD TO CART (product card) ===
function addToCart(variantId, btn) {
  const original = btn.textContent;
  btn.textContent = t('adding');
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
  })
  .then(r => {
    if (!r.ok) throw new Error('Network response was not ok: ' + r.status);
    return r.json();
  })
  .then(data => {
    if (data.status && data.status !== 200) throw new Error(data.description || 'Cart error');
    btn.textContent = t('added');
    updateCartCount();
    setTimeout(() => {
      btn.innerHTML = original;
      btn.disabled = false;
    }, 2000);
  })
  .catch((err) => {
    console.error('AddToCart error:', err);
    btn.textContent = t('error');
    btn.disabled = false;
    setTimeout(() => {
      btn.innerHTML = original;
      btn.disabled = false;
    }, 2000);
  });
}

// === ADD TO CART (product page) ===
function addToCartFromPage() {
  const btn = document.getElementById('atc-btn');
  const variantId = btn.dataset.variantId;
  const qty = parseInt(document.getElementById('quantity')?.value || 1);

  const original = btn.innerHTML;
  btn.textContent = t('adding');
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent = t('addedToCart');
    updateCartCount();
    setTimeout(() => {
      btn.innerHTML = original;
      btn.disabled = false;
    }, 2500);
  })
  .catch(() => {
    btn.textContent = t('errorRetry');
    btn.disabled = false;
  });
}

// === QUANTITY CONTROL (product page) ===
function changeQty(delta) {
  const input = document.getElementById('quantity');
  if (!input) return;
  const newVal = Math.max(1, parseInt(input.value) + delta);
  input.value = newVal;
}

// === VARIANT SWITCH (product page) ===
function updateVariant(select) {
  const opt = select.options[select.selectedIndex];
  const price = opt.dataset.price;
  const btn = document.getElementById('atc-btn');
  const priceEl = document.getElementById('product-price');

  if (btn) btn.dataset.variantId = select.value;
  if (priceEl && price) priceEl.textContent = price;
}

// Init price on page load to match default selected variant
document.addEventListener('DOMContentLoaded', function() {
  const variantSelect = document.getElementById('variant-select');
  if (variantSelect) updateVariant(variantSelect);
});

// === GALLERY (product page) ===
function switchImage(src, thumb) {
  const main = document.getElementById('main-image');
  if (main) main.src = src;
  document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
  if (thumb) thumb.classList.add('active');
}

// === CART UPDATE ===
function updateCartItem(key, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(() => location.reload());
}

// === COLLECTION SORT ===
function sortCollection(val) {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', val);
  window.location.href = url.toString();
}

// === HEADER SCROLL EFFECT ===
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 20) {
      header.style.borderBottomColor = 'rgba(201,168,76,0.15)';
    } else {
      header.style.borderBottomColor = 'rgba(255,255,255,0.06)';
    }
  }, { passive: true });
}

// === INIT ===
updateCartCount();

// === FAQ TOGGLE ===
function toggleFaq(btn) {
  const answer = btn.nextElementSibling;
  const isOpen = btn.classList.contains('open');

  // Close all
  document.querySelectorAll('.faq-question.open').forEach(q => {
    q.classList.remove('open');
    q.nextElementSibling.classList.remove('open');
  });

  // Open clicked if it wasn't already open
  if (!isOpen) {
    btn.classList.add('open');
    answer.classList.add('open');
  }
}

// === MOBILE NAV DRAWER ===
(function() {
  const btn     = document.getElementById('mobile-menu-btn');
  const nav     = document.getElementById('mobile-nav');
  const overlay = document.getElementById('mobile-nav-overlay');
  const close   = document.getElementById('mobile-nav-close');

  if (!btn || !nav || !overlay) return;

  function openNav() {
    nav.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    nav.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  btn.addEventListener('click', openNav);
  if (close) close.addEventListener('click', closeNav);
  overlay.addEventListener('click', closeNav);

  // Close on nav link tap
  nav.querySelectorAll('.mobile-nav__link').forEach(link => {
    link.addEventListener('click', closeNav);
  });

})();

// === SEARCH DROPDOWN ===
(function() {
  const widget   = document.getElementById('search-widget');
  const toggle   = document.getElementById('search-toggle-btn');
  const dropdown = document.getElementById('search-dropdown');
  const input    = document.getElementById('search-input');

  if (!widget || !toggle || !dropdown || !input) return;

  function openSearch() {
    dropdown.classList.add('active');
    toggle.classList.add('active');
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(() => input.focus(), 50);
  }
  function closeSearch() {
    dropdown.classList.remove('active');
    toggle.classList.remove('active');
    toggle.setAttribute('aria-expanded', 'false');
  }
  function isOpen() {
    return dropdown.classList.contains('active');
  }

  toggle.addEventListener('click', (e) => {
    e.stopPropagation();
    isOpen() ? closeSearch() : openSearch();
  });

  document.addEventListener('click', (e) => {
    if (isOpen() && !widget.contains(e.target)) closeSearch();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) closeSearch();
  });
})();
